export { NgTranscludeDirective } from './ng-transclude.directive';
export { TabDirective } from './tab.directive';
export { TabHeadingDirective } from './tab-heading.directive';
export { TabsetComponent } from './tabset.component';
export { TabsetConfig } from './tabset.config';
export { TabsModule } from './tabs.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/tabs/index.js
// module id = 1048
// module chunks = 26